
import { butter } from "../plugins/buttercms";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ProductFetchMixin from "~/mixin/product-fetch-mixin";
import Product from "~/types/Product";
import CMSProduct from "~/types/cms/CMSProduct";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import schemaArticle from '~/utils/articleSchema.js'

export default {
  name: "subscription",
  mixins: [ProductMapMixin, ProductFetchMixin],
  data() {
    return {
      showDeliverySelectionPopUp: true,
      subscriptionList: [] as any,
      pageData: {} as any,
      metaTags: null,
      region: "",
      para: {},
      articleSchemaStructure:schemaArticle,
      valuePropSchema:[],
      calMomentsSectionSchema:{},
    };
  },
  created() {
    this.getSubscriptionList();
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "*",
        "subscriptions-landing-page",
        {
          locale: this.$i18n.getLocaleCookie(),
          timeout: 10000,
        }
      );
      this.pageData = page?.data.data.fields;
      this.metaTags = this.pageData.seo;
      this.setupValuePropSchema(page)
      this.setupCalMomentsSectionSchema(page);
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    async getSubscriptionList() {
      this.subscriptionList = [];
      try {
        const prods = await butter(this.$config).content.retrieve(
          ["subscriptions"],
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        let customSubPara = "";
        let onGoingSubPara = "";
        let customSub6Para = "";
        let customSub3Para = "";
        let customSubMdayPara = "";
        let customSubWinterPara = "";
        let customSubBDayPara = "";
        let customSubVDayPara = "";

        prods?.data.data.subscriptions.forEach((product: any) => {
          if (product.product_type.key === "Subscription-Ongoing") {
            onGoingSubPara = product.product_tile_para;
          }
          if (product.product_type.key === "Subscription") {
            customSubPara = product.product_tile_para;
          }
          if (product.product_type.key === "Subscription-6") {
            customSub6Para = product.product_tile_para;
          }

          if (product.product_type.key === 'mothers-day-subscription') {
            customSubMdayPara = product.product_tile_para;
          }

          if(product.product_type.key === 'Subscription-3'){
             if(product.display_name.includes('Winter Subscription')){
              customSubWinterPara = product.product_tile_para;
            }else if (product.display_name.includes('Birthday Subscription')){
              customSubBDayPara = product.product_tile_para;
            }else if (product.display_name.includes('Valentines Day Subscription')){
              customSubVDayPara = product.product_tile_para;
            }else{
              customSub3Para = product.product_tile_para;
            }
          }
        });

        this.para = {
          customSubPara: customSubPara,
          onGoingSubPara: onGoingSubPara,
          customSub6Para: customSub6Para,
          customSub3Para:customSub3Para,
          customSubMdayPara:customSubMdayPara,
          customSubWinterPara:customSubWinterPara,
          customSubBDayPara:customSubBDayPara,
          customSubVDayPara:customSubVDayPara
        };
        let cmsProductData: CMSProduct[] = prods?.data.data.subscriptions;
        const locale = this.$i18n.locale;
        const countryCode = locale.split("-")[1];

        await this.getSubscriptions({
          queryId: "products_with_product_type_multi_week",
          region: countryCode,
        });

        this.subscriptionResponse.forEach((element: ShopifyProduct) => {
          let product = new Product(element, cmsProductData);
          this.subscriptionList.push(product);
        });
      } catch (error) {
        console.error(error);
      }
    },
    scrollToReviews() {
      let element = document.getElementById("sub-reviews");
      element?.scrollIntoView({ behavior: "smooth" });
    },
    setupValuePropSchema(page:any){
      this.pageData['value_props']['value_prop'].forEach(vp =>{
        let articleSchema = { ...this.articleSchemaStructure }
        articleSchema.image = [...(this.articleSchemaStructure.image || [])];
        articleSchema.headline=vp.heading
        articleSchema.description=vp.para
        articleSchema.image.push(vp.img)
        articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/bouquet-subscription'
        articleSchema.datePublished=page?.data.data.published
        articleSchema.dateModified=page?.data.data.updated
        this.valuePropSchema.push(articleSchema)
      })
    },
    setupCalMomentsSectionSchema(page:any){
        let articleSchema = { ...this.articleSchemaStructure }
        articleSchema.headline=this.pageData['cal_image_carousel'][0].fields.heading
        articleSchema.description=this.pageData['cal_image_carousel'][0].fields.paragraph
        articleSchema.image=this.pageData['cal_image_carousel'][0].fields['cal-carousel-image'];
        articleSchema.mainEntityOfPage['@id']='https://callia.com/en-ca/bouquet-subscription'
        articleSchema.datePublished=page?.data.data.published
        articleSchema.dateModified=page?.data.data.updated
        this.calMomentsSectionSchema=articleSchema;
    },
  },
};
